<template>
  <TabView v-model:activeIndex="activeTabIndex" class="custom-tabview">
    <TabPanel header="Atrasadas" class="custom-tabpanel">
      <late />
    </TabPanel>
    <TabPanel header="Pagas" class="custom-tabpanel">
      <paid />
    </TabPanel>
    <TabPanel header="Futuras" class="custom-tabpanel">
      <next />
    </TabPanel>
  </TabView>
</template>

<script setup>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Late from './DetailedExtractComponents/Late.vue';
import Next from './DetailedExtractComponents/Next.vue';
import Paid from './DetailedExtractComponents/Paid.vue';
import { onBeforeMount, ref } from 'vue';

const activeTabIndex = ref(0);

onBeforeMount(() => {
  const savedTab = localStorage.getItem('FinancialTab');
  activeTabIndex.value = savedTab ? Number(savedTab) : 0;
});
</script>

<style>
.custom-tabview .p-tabview-nav {
  border-radius: 13px;
  flex: 1 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center;
}

.custom-tabview .p-tabview-panels {
  border-radius: 13px;
}

.custom-tabpanel {
  border-radius: 13px;
}
</style>
